import {httpService} from "@/modules/common/services";

const apiCall = async (api , route, params, paramsSerializer) => {
  let res;

  try {
    res = await api(route, params, paramsSerializer);
  } catch(e) {
    const response = e.response
    if (!response) { // for general exeptions that not from api
      res = {error: e.message}
    } else if (response.data.errors && Array.isArray(response.data.errors)) { // for new apis
      res = {error: response.data.errors[0].message , status: response.status, code: response.data.errors[0].code, field: response.data.errors[0].field}
    } else {
      res = {errors: response.data, status: response.status, code: response.code, field: response.field}
    }
  }

  if (res.error || res.errors) {
    throw res
  }

  return {data: res.data || res}
};
export const getQuery = (route, params, paramsSerializer) => apiCall(httpService.get, route, params, paramsSerializer)
export const postQuery = (route, params) => apiCall(httpService.post, route, params)
export const putQuery = (route, params) => apiCall(httpService.put, route, params)
export const removeQuery = (route, params) => apiCall(httpService.remove, route, params)
